import { render, staticRenderFns } from "./PriceModal.vue?vue&type=template&id=0fdc4480&scoped=true"
import script from "./PriceModal.vue?vue&type=script&lang=js"
export * from "./PriceModal.vue?vue&type=script&lang=js"
import style0 from "./PriceModal.vue?vue&type=style&index=0&id=0fdc4480&prod&lang=scss"
import style1 from "./PriceModal.vue?vue&type=style&index=1&id=0fdc4480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc4480",
  null
  
)

export default component.exports